import { default as _404UqQE6fJJy1Meta } from "/webs/pages/404.vue?macro=true";
import { default as balanceEdcMGJXvv7Meta } from "/webs/pages/account/balance.vue?macro=true";
import { default as coinsTCK7QSWFqAMeta } from "/webs/pages/account/coins.vue?macro=true";
import { default as coinsInfowvZw0RqzXXMeta } from "/webs/pages/account/coinsInfo.vue?macro=true";
import { default as emailfx3Dgr5DBPMeta } from "/webs/pages/account/email.vue?macro=true";
import { default as phoneNumbervgeuRPCqOvMeta } from "/webs/pages/account/phoneNumber.vue?macro=true";
import { default as settingPasswordCKW7QCxD6KMeta } from "/webs/pages/account/settingPassword.vue?macro=true";
import { default as whatsApp1Z6JtDVM27Meta } from "/webs/pages/account/whatsApp.vue?macro=true";
import { default as _91addressId_93MIbQj8fNzgMeta } from "/webs/pages/address/[addressId].vue?macro=true";
import { default as indexg0Y2APCeBaMeta } from "/webs/pages/address/index.vue?macro=true";
import { default as select_area__91addressId_93HJLFdKxtJ3Meta } from "/webs/pages/address/select_area_[addressId].vue?macro=true";
import { default as _91id_93UONusE63RnMeta } from "/webs/pages/after-sale/[id].vue?macro=true";
import { default as applyVhUpbhpcrmMeta } from "/webs/pages/after-sale/apply.vue?macro=true";
import { default as complaint__91id_93Ya18DTR6LlMeta } from "/webs/pages/after-sale/complaint_[id].vue?macro=true";
import { default as afterBottomBtnTLdwgq7njhMeta } from "/webs/pages/after-sale/component/afterBottomBtn.vue?macro=true";
import { default as afterDetailsCardMLB0a61KF7Meta } from "/webs/pages/after-sale/component/afterDetailsCard.vue?macro=true";
import { default as afterDetailsCardNewOxK9RnDLqUMeta } from "/webs/pages/after-sale/component/afterDetailsCardNew.vue?macro=true";
import { default as afterFileRemarkFvz8eefixcMeta } from "/webs/pages/after-sale/component/afterFileRemark.vue?macro=true";
import { default as afterGoodsCard9z2NlRjPClMeta } from "/webs/pages/after-sale/component/afterGoodsCard.vue?macro=true";
import { default as AfterSalePagez4TQrSREq6Meta } from "/webs/pages/after-sale/component/AfterSalePage.vue?macro=true";
import { default as afterTypeGnpupeY9RiMeta } from "/webs/pages/after-sale/component/afterType.vue?macro=true";
import { default as evaluation2SLLiADBxQMeta } from "/webs/pages/after-sale/evaluation.vue?macro=true";
import { default as indexIdo1UqjZaAMeta } from "/webs/pages/after-sale/index.vue?macro=true";
import { default as log_info__91id_93qSeuNrMdSHMeta } from "/webs/pages/after-sale/log_info_[id].vue?macro=true";
import { default as return__91id_93WfmsDWmctaMeta } from "/webs/pages/after-sale/return_[id].vue?macro=true";
import { default as ruleIofWCQvJ9SMeta } from "/webs/pages/after-sale/rule.vue?macro=true";
import { default as service_type__91id_93mBQqhRbap9Meta } from "/webs/pages/after-sale/service_type_[id].vue?macro=true";
import { default as afterSalePcEYuyOpZKVGMeta } from "/webs/pages/afterSalePc.vue?macro=true";
import { default as all_45categorymNDMAN0b8UMeta } from "/webs/pages/all-category.vue?macro=true";
import { default as _91categoryName_93E8QGXOJJvZMeta } from "/webs/pages/category/[categoryName].vue?macro=true";
import { default as checkCodeGGsqMcA2ZIMeta } from "/webs/pages/checkCode.vue?macro=true";
import { default as AddressCardJbWMvcTPk0Meta } from "/webs/pages/checkout/_widgets/AddressCard.vue?macro=true";
import { default as VoucherPopupRDb2pda1D8Meta } from "/webs/pages/checkout/_widgets/VoucherPopup.vue?macro=true";
import { default as indexpGhQAEt5E2Meta } from "/webs/pages/checkout/index.vue?macro=true";
import { default as coinsKSEsdFtSY1Meta } from "/webs/pages/coins.vue?macro=true";
import { default as compatibilityBvlfNZ491TMeta } from "/webs/pages/compatibility.vue?macro=true";
import { default as downloadAppQPFUN7x6UnMeta } from "/webs/pages/downloadApp.vue?macro=true";
import { default as _91pageSlug_93707t7BWha4Meta } from "/webs/pages/event/[pageSlug].vue?macro=true";
import { default as faqEcB4YAjrbxMeta } from "/webs/pages/faq.vue?macro=true";
import { default as favorite_45storebmxAcVGegkMeta } from "/webs/pages/favorite-store.vue?macro=true";
import { default as flash_45salesyt0h1SgMdAMeta } from "/webs/pages/flash-sales.vue?macro=true";
import { default as indexCkTrEgvqCUMeta } from "/webs/pages/index.vue?macro=true";
import { default as applicationyDjjzZzwjgMeta } from "/webs/pages/kforce/application.vue?macro=true";
import { default as indexsYttAtf59PMeta } from "/webs/pages/kforce/index.vue?macro=true";
import { default as ordersua0LH5IYi5Meta } from "/webs/pages/kforce/orders.vue?macro=true";
import { default as registerknqbM3xc25Meta } from "/webs/pages/kforce/register.vue?macro=true";
import { default as live_45chatI6ZnaQYYwaMeta } from "/webs/pages/kilicms/live-chat.vue?macro=true";
import { default as _91storeId_93UJPpcli3dRMeta } from "/webs/pages/ks-share-store/[storeId].vue?macro=true";
import { default as _91id_93fv0jJ5IvlgMeta } from "/webs/pages/listing/[id].vue?macro=true";
import { default as login_45errorG9M5W3egveMeta } from "/webs/pages/login-error.vue?macro=true";
import { default as login5I6w5tTwwaMeta } from "/webs/pages/login.vue?macro=true";
import { default as _91orderNum_93NuwPmB79PtMeta } from "/webs/pages/logistics/[orderNum].vue?macro=true";
import { default as orderqueryeYsUsygSPnMeta } from "/webs/pages/logistics/orderquery.vue?macro=true";
import { default as _91id_931D0lEzIA5tMeta } from "/webs/pages/logistics/pickupDetail/[id].vue?macro=true";
import { default as close_45accounts94Sbo4wo2Meta } from "/webs/pages/logout-account/close-account.vue?macro=true";
import { default as Step1We3PAgYk09Meta } from "/webs/pages/logout-account/Step1.vue?macro=true";
import { default as Step2N1niEuovrgMeta } from "/webs/pages/logout-account/Step2.vue?macro=true";
import { default as Step3DNer6OcnaZMeta } from "/webs/pages/logout-account/Step3.vue?macro=true";
import { default as lucky_45wheellFGaIKR0VWMeta } from "/webs/pages/marketing-activity/lucky-wheel.vue?macro=true";
import { default as chatfFf1UppiLMMeta } from "/webs/pages/message/chat.vue?macro=true";
import { default as indexZ9vSC3HBl3Meta } from "/webs/pages/message/index.vue?macro=true";
import { default as station_45lettersJQoKhpZOL8Meta } from "/webs/pages/message/station-letters.vue?macro=true";
import { default as store_45chatypSgjtpF88Meta } from "/webs/pages/message/store-chat.vue?macro=true";
import { default as _91id_93GdvX9ieP3RMeta } from "/webs/pages/new-after-sale/[id].vue?macro=true";
import { default as applyDu2YJVZFmEMeta } from "/webs/pages/new-after-sale/apply.vue?macro=true";
import { default as complaint__91id_93pjCmPoYOqmMeta } from "/webs/pages/new-after-sale/complaint_[id].vue?macro=true";
import { default as evaluationV94qe6mSeSMeta } from "/webs/pages/new-after-sale/evaluation.vue?macro=true";
import { default as history__91id_93pcA0lUYEapMeta } from "/webs/pages/new-after-sale/history_[id].vue?macro=true";
import { default as indexyhsJF2dyTYMeta } from "/webs/pages/new-after-sale/index.vue?macro=true";
import { default as refund_45initiatedlN3bAE9hBFMeta } from "/webs/pages/new-after-sale/refund-initiated.vue?macro=true";
import { default as return__91id_93rZvJav31JuMeta } from "/webs/pages/new-after-sale/return_[id].vue?macro=true";
import { default as new_45arrivalu0Hbmg9TTQMeta } from "/webs/pages/new-arrival.vue?macro=true";
import { default as _91id_936WxlFZ8Dx0Meta } from "/webs/pages/newUserUrl/[id].vue?macro=true";
import { default as oauth2_45authorizeRgZTdW5Du1Meta } from "/webs/pages/oauth2-authorize.vue?macro=true";
import { default as delIjDs18ppGpMeta } from "/webs/pages/orders/del.vue?macro=true";
import { default as detail__91oid_93fiIKxhxqqgMeta } from "/webs/pages/orders/detail_[oid].vue?macro=true";
import { default as indexIXDzIxpQYOMeta } from "/webs/pages/orders/index.vue?macro=true";
import { default as old_k_order_iframelXyqQThifpMeta } from "/webs/pages/orders/old_k_order_iframe.vue?macro=true";
import { default as order_cancel__91id_93x8lFg8yMz4Meta } from "/webs/pages/orders/order_cancel_[id].vue?macro=true";
import { default as _91oid_935XBQtjM6BlMeta } from "/webs/pages/orders/proof-of-order/[oid].vue?macro=true";
import { default as proxy_45paymentmE9nZ7GXOrMeta } from "/webs/pages/orders/proxy-payment.vue?macro=true";
import { default as refund__91oid_93Xpb26iuvu5Meta } from "/webs/pages/orders/refund_[oid].vue?macro=true";
import { default as payment_45resultqkVVaixRjsMeta } from "/webs/pages/payment-result.vue?macro=true";
import { default as _91video_93AqyZNgzwfhMeta } from "/webs/pages/player-video/product/[video].vue?macro=true";
import { default as _91bid_93IWxVWbwJ3KMeta } from "/webs/pages/promotion-listings/[bid].vue?macro=true";
import { default as _SelectSkuVMvo3WNDlrMeta } from "/webs/pages/promotion-listings/widgets/_SelectSku.vue?macro=true";
import { default as pvHomeX3Amcdl6gjMeta } from "/webs/pages/pvHome.vue?macro=true";
import { default as quick_45reg_45bindingHgcWkfkRmkMeta } from "/webs/pages/quick-reg-binding.vue?macro=true";
import { default as recent_45viewsar5UTl33GIMeta } from "/webs/pages/recent-views.vue?macro=true";
import { default as _91id_93UhamltwnxFMeta } from "/webs/pages/refund/[id].vue?macro=true";
import { default as applyutNyH2ZMjgMeta } from "/webs/pages/reviews-publish/apply.vue?macro=true";
import { default as indexzxJ3cmGHMBMeta } from "/webs/pages/reviews-publish/index.vue?macro=true";
import { default as _91listingId_93mYqjEIIgluMeta } from "/webs/pages/reviews/[listingId].vue?macro=true";
import { default as detail__91id_93K645gSn7XxMeta } from "/webs/pages/reviews/detail_[id].vue?macro=true";
import { default as search_45inputBhFGHgiUXAMeta } from "/webs/pages/search-input.vue?macro=true";
import { default as searchiUQebtGDVRMeta } from "/webs/pages/search.vue?macro=true";
import { default as set_45invitationB5kopb1NUvMeta } from "/webs/pages/set-invitation.vue?macro=true";
import { default as set_45pwdSzHmPwvesFMeta } from "/webs/pages/set-pwd.vue?macro=true";
import { default as aboutmnznSmJj8OMeta } from "/webs/pages/setting/account/about.vue?macro=true";
import { default as country7GZUXFj8slMeta } from "/webs/pages/setting/account/country.vue?macro=true";
import { default as email_45subscribeQlFNEB0GSgMeta } from "/webs/pages/setting/account/email-subscribe.vue?macro=true";
import { default as emailz50NSG5HrVMeta } from "/webs/pages/setting/account/email.vue?macro=true";
import { default as index4KbLPBQDmtMeta } from "/webs/pages/setting/account/index.vue?macro=true";
import { default as messageNHaF0oDSEhMeta } from "/webs/pages/setting/account/message.vue?macro=true";
import { default as password9EWSrLtWATMeta } from "/webs/pages/setting/account/password.vue?macro=true";
import { default as phoneTTNURxYpqqMeta } from "/webs/pages/setting/account/phone.vue?macro=true";
import { default as whatsAppkxBY7V9EdOMeta } from "/webs/pages/setting/account/whatsApp.vue?macro=true";
import { default as shopping_45cart0IM1AO7TjKMeta } from "/webs/pages/shopping-cart.vue?macro=true";
import { default as sitemap_46htmlDZuHt1BJQNMeta } from "/webs/pages/sitemap.html.vue?macro=true";
import { default as AdvListOvOXrIaAfKMeta } from "/webs/pages/store/_cms/AdvList.vue?macro=true";
import { default as CutImageKsGkN1g2BWMeta } from "/webs/pages/store/_cms/CutImage.vue?macro=true";
import { default as GoodsListUD29qImimlMeta } from "/webs/pages/store/_cms/GoodsList.vue?macro=true";
import { default as TitleBarjkAFKYPsTjMeta } from "/webs/pages/store/_cms/TitleBar.vue?macro=true";
import { default as _91id_93ZT6B6b1ZdpMeta } from "/webs/pages/store/[id].vue?macro=true";
import { default as subscribeQhtDay1P5fMeta } from "/webs/pages/subscribe.vue?macro=true";
import { default as user_45centerHZtKLeVklhMeta } from "/webs/pages/user-center.vue?macro=true";
import { default as auto_45getfwC9Cz4j1wMeta } from "/webs/pages/voucher/auto-get.vue?macro=true";
import { default as indexMSGDZy0G83Meta } from "/webs/pages/voucher/index.vue?macro=true";
import { default as wish_45listnGfF3fHIKmMeta } from "/webs/pages/wish-list.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/webs/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "account-balance",
    path: "/account/balance",
    meta: balanceEdcMGJXvv7Meta || {},
    component: () => import("/webs/pages/account/balance.vue").then(m => m.default || m)
  },
  {
    name: "account-coins",
    path: "/account/coins",
    meta: coinsTCK7QSWFqAMeta || {},
    component: () => import("/webs/pages/account/coins.vue").then(m => m.default || m)
  },
  {
    name: "account-coinsInfo",
    path: "/account/coinsInfo",
    meta: coinsInfowvZw0RqzXXMeta || {},
    component: () => import("/webs/pages/account/coinsInfo.vue").then(m => m.default || m)
  },
  {
    name: "account-email",
    path: "/account/email",
    meta: emailfx3Dgr5DBPMeta || {},
    component: () => import("/webs/pages/account/email.vue").then(m => m.default || m)
  },
  {
    name: "account-phoneNumber",
    path: "/account/phoneNumber",
    meta: phoneNumbervgeuRPCqOvMeta || {},
    component: () => import("/webs/pages/account/phoneNumber.vue").then(m => m.default || m)
  },
  {
    name: "account-settingPassword",
    path: "/account/settingPassword",
    meta: settingPasswordCKW7QCxD6KMeta || {},
    component: () => import("/webs/pages/account/settingPassword.vue").then(m => m.default || m)
  },
  {
    name: "account-whatsApp",
    path: "/account/whatsApp",
    meta: whatsApp1Z6JtDVM27Meta || {},
    component: () => import("/webs/pages/account/whatsApp.vue").then(m => m.default || m)
  },
  {
    name: "address-addressId",
    path: "/address/:addressId()",
    meta: _91addressId_93MIbQj8fNzgMeta || {},
    component: () => import("/webs/pages/address/[addressId].vue").then(m => m.default || m)
  },
  {
    name: "address",
    path: "/address",
    meta: indexg0Y2APCeBaMeta || {},
    component: () => import("/webs/pages/address/index.vue").then(m => m.default || m)
  },
  {
    name: "address-select_area_addressId",
    path: "/address/select_area_:addressId()",
    meta: select_area__91addressId_93HJLFdKxtJ3Meta || {},
    component: () => import("/webs/pages/address/select_area_[addressId].vue").then(m => m.default || m)
  },
  {
    name: "after-sale-id",
    path: "/after-sale/:id()",
    meta: _91id_93UONusE63RnMeta || {},
    component: () => import("/webs/pages/after-sale/[id].vue").then(m => m.default || m)
  },
  {
    name: "after-sale-apply",
    path: "/after-sale/apply",
    meta: applyVhUpbhpcrmMeta || {},
    component: () => import("/webs/pages/after-sale/apply.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-complaint_id",
    path: "/after-sale/complaint_:id()",
    meta: complaint__91id_93Ya18DTR6LlMeta || {},
    component: () => import("/webs/pages/after-sale/complaint_[id].vue").then(m => m.default || m)
  },
  {
    name: "after-sale-component-afterBottomBtn",
    path: "/after-sale/component/afterBottomBtn",
    component: () => import("/webs/pages/after-sale/component/afterBottomBtn.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-component-afterDetailsCard",
    path: "/after-sale/component/afterDetailsCard",
    component: () => import("/webs/pages/after-sale/component/afterDetailsCard.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-component-afterDetailsCardNew",
    path: "/after-sale/component/afterDetailsCardNew",
    component: () => import("/webs/pages/after-sale/component/afterDetailsCardNew.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-component-afterFileRemark",
    path: "/after-sale/component/afterFileRemark",
    component: () => import("/webs/pages/after-sale/component/afterFileRemark.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-component-afterGoodsCard",
    path: "/after-sale/component/afterGoodsCard",
    component: () => import("/webs/pages/after-sale/component/afterGoodsCard.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-component-AfterSalePage",
    path: "/after-sale/component/AfterSalePage",
    meta: AfterSalePagez4TQrSREq6Meta || {},
    component: () => import("/webs/pages/after-sale/component/AfterSalePage.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-component-afterType",
    path: "/after-sale/component/afterType",
    component: () => import("/webs/pages/after-sale/component/afterType.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-evaluation",
    path: "/after-sale/evaluation",
    meta: evaluation2SLLiADBxQMeta || {},
    component: () => import("/webs/pages/after-sale/evaluation.vue").then(m => m.default || m)
  },
  {
    name: "after-sale",
    path: "/after-sale",
    component: () => import("/webs/pages/after-sale/index.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-log_info_id",
    path: "/after-sale/log_info_:id()",
    meta: log_info__91id_93qSeuNrMdSHMeta || {},
    component: () => import("/webs/pages/after-sale/log_info_[id].vue").then(m => m.default || m)
  },
  {
    name: "after-sale-return_id",
    path: "/after-sale/return_:id()",
    meta: return__91id_93WfmsDWmctaMeta || {},
    component: () => import("/webs/pages/after-sale/return_[id].vue").then(m => m.default || m)
  },
  {
    name: "after-sale-rule",
    path: "/after-sale/rule",
    meta: ruleIofWCQvJ9SMeta || {},
    component: () => import("/webs/pages/after-sale/rule.vue").then(m => m.default || m)
  },
  {
    name: "after-sale-service_type_id",
    path: "/after-sale/service_type_:id()",
    meta: service_type__91id_93mBQqhRbap9Meta || {},
    component: () => import("/webs/pages/after-sale/service_type_[id].vue").then(m => m.default || m)
  },
  {
    name: "afterSalePc",
    path: "/afterSalePc",
    component: () => import("/webs/pages/afterSalePc.vue").then(m => m.default || m)
  },
  {
    name: "all-category",
    path: "/all-category",
    meta: all_45categorymNDMAN0b8UMeta || {},
    component: () => import("/webs/pages/all-category.vue").then(m => m.default || m)
  },
  {
    name: "category-categoryName",
    path: "/category/:categoryName()",
    meta: _91categoryName_93E8QGXOJJvZMeta || {},
    component: () => import("/webs/pages/category/[categoryName].vue").then(m => m.default || m)
  },
  {
    name: "checkCode",
    path: "/checkCode",
    component: () => import("/webs/pages/checkCode.vue").then(m => m.default || m)
  },
  {
    name: "checkout-_widgets-AddressCard",
    path: "/checkout/_widgets/AddressCard",
    component: () => import("/webs/pages/checkout/_widgets/AddressCard.vue").then(m => m.default || m)
  },
  {
    name: "checkout-_widgets-VoucherPopup",
    path: "/checkout/_widgets/VoucherPopup",
    component: () => import("/webs/pages/checkout/_widgets/VoucherPopup.vue").then(m => m.default || m)
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: indexpGhQAEt5E2Meta || {},
    component: () => import("/webs/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: "coins",
    path: "/coins",
    meta: coinsKSEsdFtSY1Meta || {},
    component: () => import("/webs/pages/coins.vue").then(m => m.default || m)
  },
  {
    name: "compatibility",
    path: "/compatibility",
    component: () => import("/webs/pages/compatibility.vue").then(m => m.default || m)
  },
  {
    name: "downloadApp",
    path: "/downloadApp",
    meta: downloadAppQPFUN7x6UnMeta || {},
    component: () => import("/webs/pages/downloadApp.vue").then(m => m.default || m)
  },
  {
    name: "event-pageSlug",
    path: "/event/:pageSlug()",
    meta: _91pageSlug_93707t7BWha4Meta || {},
    component: () => import("/webs/pages/event/[pageSlug].vue").then(m => m.default || m)
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/webs/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "favorite-store",
    path: "/favorite-store",
    meta: favorite_45storebmxAcVGegkMeta || {},
    component: () => import("/webs/pages/favorite-store.vue").then(m => m.default || m)
  },
  {
    name: "flash-sales",
    path: "/flash-sales",
    meta: flash_45salesyt0h1SgMdAMeta || {},
    component: () => import("/webs/pages/flash-sales.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexCkTrEgvqCUMeta || {},
    component: () => import("/webs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "kforce-application",
    path: "/kforce/application",
    component: () => import("/webs/pages/kforce/application.vue").then(m => m.default || m)
  },
  {
    name: "kforce",
    path: "/kforce",
    meta: indexsYttAtf59PMeta || {},
    component: () => import("/webs/pages/kforce/index.vue").then(m => m.default || m)
  },
  {
    name: "kforce-orders",
    path: "/kforce/orders",
    meta: ordersua0LH5IYi5Meta || {},
    component: () => import("/webs/pages/kforce/orders.vue").then(m => m.default || m)
  },
  {
    name: "kforce-register",
    path: "/kforce/register",
    component: () => import("/webs/pages/kforce/register.vue").then(m => m.default || m)
  },
  {
    name: "kilicms-live-chat",
    path: "/kilicms/live-chat",
    component: () => import("/webs/pages/kilicms/live-chat.vue").then(m => m.default || m)
  },
  {
    name: "ks-share-store-storeId",
    path: "/ks-share-store/:storeId()",
    meta: _91storeId_93UJPpcli3dRMeta || {},
    component: () => import("/webs/pages/ks-share-store/[storeId].vue").then(m => m.default || m)
  },
  {
    name: "listing-id",
    path: "/listing/:id()",
    meta: _91id_93fv0jJ5IvlgMeta || {},
    component: () => import("/webs/pages/listing/[id].vue").then(m => m.default || m)
  },
  {
    name: "login-error",
    path: "/login-error",
    meta: login_45errorG9M5W3egveMeta || {},
    component: () => import("/webs/pages/login-error.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: login5I6w5tTwwaMeta || {},
    component: () => import("/webs/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "logistics-orderNum",
    path: "/logistics/:orderNum()",
    component: () => import("/webs/pages/logistics/[orderNum].vue").then(m => m.default || m)
  },
  {
    name: "logistics-orderquery",
    path: "/logistics/orderquery",
    component: () => import("/webs/pages/logistics/orderquery.vue").then(m => m.default || m)
  },
  {
    name: "logistics-pickupDetail-id",
    path: "/logistics/pickupDetail/:id()",
    component: () => import("/webs/pages/logistics/pickupDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "logout-account-close-account",
    path: "/logout-account/close-account",
    component: () => import("/webs/pages/logout-account/close-account.vue").then(m => m.default || m)
  },
  {
    name: "logout-account-Step1",
    path: "/logout-account/Step1",
    component: () => import("/webs/pages/logout-account/Step1.vue").then(m => m.default || m)
  },
  {
    name: "logout-account-Step2",
    path: "/logout-account/Step2",
    component: () => import("/webs/pages/logout-account/Step2.vue").then(m => m.default || m)
  },
  {
    name: "logout-account-Step3",
    path: "/logout-account/Step3",
    component: () => import("/webs/pages/logout-account/Step3.vue").then(m => m.default || m)
  },
  {
    name: "marketing-activity-lucky-wheel",
    path: "/marketing-activity/lucky-wheel",
    meta: lucky_45wheellFGaIKR0VWMeta || {},
    component: () => import("/webs/pages/marketing-activity/lucky-wheel.vue").then(m => m.default || m)
  },
  {
    name: "message-chat",
    path: "/message/chat",
    component: () => import("/webs/pages/message/chat.vue").then(m => m.default || m)
  },
  {
    name: "message",
    path: "/message",
    meta: indexZ9vSC3HBl3Meta || {},
    component: () => import("/webs/pages/message/index.vue").then(m => m.default || m)
  },
  {
    name: "message-station-letters",
    path: "/message/station-letters",
    meta: station_45lettersJQoKhpZOL8Meta || {},
    component: () => import("/webs/pages/message/station-letters.vue").then(m => m.default || m)
  },
  {
    name: "message-store-chat",
    path: "/message/store-chat",
    meta: store_45chatypSgjtpF88Meta || {},
    component: () => import("/webs/pages/message/store-chat.vue").then(m => m.default || m)
  },
  {
    name: "new-after-sale-id",
    path: "/new-after-sale/:id()",
    component: () => import("/webs/pages/new-after-sale/[id].vue").then(m => m.default || m)
  },
  {
    name: "new-after-sale-apply",
    path: "/new-after-sale/apply",
    component: () => import("/webs/pages/new-after-sale/apply.vue").then(m => m.default || m)
  },
  {
    name: "new-after-sale-complaint_id",
    path: "/new-after-sale/complaint_:id()",
    meta: complaint__91id_93pjCmPoYOqmMeta || {},
    component: () => import("/webs/pages/new-after-sale/complaint_[id].vue").then(m => m.default || m)
  },
  {
    name: "new-after-sale-evaluation",
    path: "/new-after-sale/evaluation",
    component: () => import("/webs/pages/new-after-sale/evaluation.vue").then(m => m.default || m)
  },
  {
    name: "new-after-sale-history_id",
    path: "/new-after-sale/history_:id()",
    meta: history__91id_93pcA0lUYEapMeta || {},
    component: () => import("/webs/pages/new-after-sale/history_[id].vue").then(m => m.default || m)
  },
  {
    name: "new-after-sale",
    path: "/new-after-sale",
    component: () => import("/webs/pages/new-after-sale/index.vue").then(m => m.default || m)
  },
  {
    name: "new-after-sale-refund-initiated",
    path: "/new-after-sale/refund-initiated",
    component: () => import("/webs/pages/new-after-sale/refund-initiated.vue").then(m => m.default || m)
  },
  {
    name: "new-after-sale-return_id",
    path: "/new-after-sale/return_:id()",
    meta: return__91id_93rZvJav31JuMeta || {},
    component: () => import("/webs/pages/new-after-sale/return_[id].vue").then(m => m.default || m)
  },
  {
    name: "new-arrival",
    path: "/new-arrival",
    meta: new_45arrivalu0Hbmg9TTQMeta || {},
    component: () => import("/webs/pages/new-arrival.vue").then(m => m.default || m)
  },
  {
    name: "newUserUrl-id",
    path: "/newUserUrl/:id()",
    component: () => import("/webs/pages/newUserUrl/[id].vue").then(m => m.default || m)
  },
  {
    name: "oauth2-authorize",
    path: "/oauth2-authorize",
    meta: oauth2_45authorizeRgZTdW5Du1Meta || {},
    component: () => import("/webs/pages/oauth2-authorize.vue").then(m => m.default || m)
  },
  {
    name: "orders-del",
    path: "/orders/del",
    meta: delIjDs18ppGpMeta || {},
    component: () => import("/webs/pages/orders/del.vue").then(m => m.default || m)
  },
  {
    name: "orders-detail_oid",
    path: "/orders/detail_:oid()",
    meta: detail__91oid_93fiIKxhxqqgMeta || {},
    component: () => import("/webs/pages/orders/detail_[oid].vue").then(m => m.default || m)
  },
  {
    name: "orders",
    path: "/orders",
    meta: indexIXDzIxpQYOMeta || {},
    component: () => import("/webs/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-old_k_order_iframe",
    path: "/orders/old_k_order_iframe",
    component: () => import("/webs/pages/orders/old_k_order_iframe.vue").then(m => m.default || m)
  },
  {
    name: "orders-order_cancel_id",
    path: "/orders/order_cancel_:id()",
    meta: order_cancel__91id_93x8lFg8yMz4Meta || {},
    component: () => import("/webs/pages/orders/order_cancel_[id].vue").then(m => m.default || m)
  },
  {
    name: "orders-proof-of-order-oid",
    path: "/orders/proof-of-order/:oid()",
    component: () => import("/webs/pages/orders/proof-of-order/[oid].vue").then(m => m.default || m)
  },
  {
    name: "orders-proxy-payment",
    path: "/orders/proxy-payment",
    meta: proxy_45paymentmE9nZ7GXOrMeta || {},
    component: () => import("/webs/pages/orders/proxy-payment.vue").then(m => m.default || m)
  },
  {
    name: "orders-refund_oid",
    path: "/orders/refund_:oid()",
    meta: refund__91oid_93Xpb26iuvu5Meta || {},
    component: () => import("/webs/pages/orders/refund_[oid].vue").then(m => m.default || m)
  },
  {
    name: "payment-result",
    path: "/payment-result",
    meta: payment_45resultqkVVaixRjsMeta || {},
    component: () => import("/webs/pages/payment-result.vue").then(m => m.default || m)
  },
  {
    name: "player-video-product-video",
    path: "/player-video/product/:video()",
    meta: _91video_93AqyZNgzwfhMeta || {},
    component: () => import("/webs/pages/player-video/product/[video].vue").then(m => m.default || m)
  },
  {
    name: "promotion-listings-bid",
    path: "/promotion-listings/:bid()",
    meta: _91bid_93IWxVWbwJ3KMeta || {},
    component: () => import("/webs/pages/promotion-listings/[bid].vue").then(m => m.default || m)
  },
  {
    name: "promotion-listings-widgets-_SelectSku",
    path: "/promotion-listings/widgets/_SelectSku",
    component: () => import("/webs/pages/promotion-listings/widgets/_SelectSku.vue").then(m => m.default || m)
  },
  {
    name: "pvHome",
    path: "/pvHome",
    component: () => import("/webs/pages/pvHome.vue").then(m => m.default || m)
  },
  {
    name: "quick-reg-binding",
    path: "/quick-reg-binding",
    component: () => import("/webs/pages/quick-reg-binding.vue").then(m => m.default || m)
  },
  {
    name: "recent-views",
    path: "/recent-views",
    meta: recent_45viewsar5UTl33GIMeta || {},
    component: () => import("/webs/pages/recent-views.vue").then(m => m.default || m)
  },
  {
    name: "refund-id",
    path: "/refund/:id()",
    component: () => import("/webs/pages/refund/[id].vue").then(m => m.default || m)
  },
  {
    name: "reviews-publish-apply",
    path: "/reviews-publish/apply",
    meta: applyutNyH2ZMjgMeta || {},
    component: () => import("/webs/pages/reviews-publish/apply.vue").then(m => m.default || m)
  },
  {
    name: "reviews-publish",
    path: "/reviews-publish",
    meta: indexzxJ3cmGHMBMeta || {},
    component: () => import("/webs/pages/reviews-publish/index.vue").then(m => m.default || m)
  },
  {
    name: "reviews-listingId",
    path: "/reviews/:listingId()",
    meta: _91listingId_93mYqjEIIgluMeta || {},
    component: () => import("/webs/pages/reviews/[listingId].vue").then(m => m.default || m)
  },
  {
    name: "reviews-detail_id",
    path: "/reviews/detail_:id()",
    meta: detail__91id_93K645gSn7XxMeta || {},
    component: () => import("/webs/pages/reviews/detail_[id].vue").then(m => m.default || m)
  },
  {
    name: "search-input",
    path: "/search-input",
    meta: search_45inputBhFGHgiUXAMeta || {},
    component: () => import("/webs/pages/search-input.vue").then(m => m.default || m)
  },
  {
    name: "search",
    path: "/search",
    meta: searchiUQebtGDVRMeta || {},
    component: () => import("/webs/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "set-invitation",
    path: "/set-invitation",
    meta: set_45invitationB5kopb1NUvMeta || {},
    component: () => import("/webs/pages/set-invitation.vue").then(m => m.default || m)
  },
  {
    name: "set-pwd",
    path: "/set-pwd",
    meta: set_45pwdSzHmPwvesFMeta || {},
    component: () => import("/webs/pages/set-pwd.vue").then(m => m.default || m)
  },
  {
    name: "setting-account-about",
    path: "/setting/account/about",
    meta: aboutmnznSmJj8OMeta || {},
    component: () => import("/webs/pages/setting/account/about.vue").then(m => m.default || m)
  },
  {
    name: "setting-account-country",
    path: "/setting/account/country",
    meta: country7GZUXFj8slMeta || {},
    component: () => import("/webs/pages/setting/account/country.vue").then(m => m.default || m)
  },
  {
    name: "setting-account-email-subscribe",
    path: "/setting/account/email-subscribe",
    component: () => import("/webs/pages/setting/account/email-subscribe.vue").then(m => m.default || m)
  },
  {
    name: "setting-account-email",
    path: "/setting/account/email",
    meta: emailz50NSG5HrVMeta || {},
    component: () => import("/webs/pages/setting/account/email.vue").then(m => m.default || m)
  },
  {
    name: "setting-account",
    path: "/setting/account",
    meta: index4KbLPBQDmtMeta || {},
    component: () => import("/webs/pages/setting/account/index.vue").then(m => m.default || m)
  },
  {
    name: "setting-account-message",
    path: "/setting/account/message",
    component: () => import("/webs/pages/setting/account/message.vue").then(m => m.default || m)
  },
  {
    name: "setting-account-password",
    path: "/setting/account/password",
    meta: password9EWSrLtWATMeta || {},
    component: () => import("/webs/pages/setting/account/password.vue").then(m => m.default || m)
  },
  {
    name: "setting-account-phone",
    path: "/setting/account/phone",
    meta: phoneTTNURxYpqqMeta || {},
    component: () => import("/webs/pages/setting/account/phone.vue").then(m => m.default || m)
  },
  {
    name: "setting-account-whatsApp",
    path: "/setting/account/whatsApp",
    meta: whatsAppkxBY7V9EdOMeta || {},
    component: () => import("/webs/pages/setting/account/whatsApp.vue").then(m => m.default || m)
  },
  {
    name: "shopping-cart",
    path: "/shopping-cart",
    meta: shopping_45cart0IM1AO7TjKMeta || {},
    component: () => import("/webs/pages/shopping-cart.vue").then(m => m.default || m)
  },
  {
    name: "sitemap.html",
    path: "/sitemap.html",
    meta: sitemap_46htmlDZuHt1BJQNMeta || {},
    component: () => import("/webs/pages/sitemap.html.vue").then(m => m.default || m)
  },
  {
    name: "store-_cms-AdvList",
    path: "/store/_cms/AdvList",
    component: () => import("/webs/pages/store/_cms/AdvList.vue").then(m => m.default || m)
  },
  {
    name: "store-_cms-CutImage",
    path: "/store/_cms/CutImage",
    component: () => import("/webs/pages/store/_cms/CutImage.vue").then(m => m.default || m)
  },
  {
    name: "store-_cms-GoodsList",
    path: "/store/_cms/GoodsList",
    component: () => import("/webs/pages/store/_cms/GoodsList.vue").then(m => m.default || m)
  },
  {
    name: "store-_cms-TitleBar",
    path: "/store/_cms/TitleBar",
    component: () => import("/webs/pages/store/_cms/TitleBar.vue").then(m => m.default || m)
  },
  {
    name: "store-id",
    path: "/store/:id()",
    meta: _91id_93ZT6B6b1ZdpMeta || {},
    component: () => import("/webs/pages/store/[id].vue").then(m => m.default || m)
  },
  {
    name: "subscribe",
    path: "/subscribe",
    meta: subscribeQhtDay1P5fMeta || {},
    component: () => import("/webs/pages/subscribe.vue").then(m => m.default || m)
  },
  {
    name: "user-center",
    path: "/user-center",
    meta: user_45centerHZtKLeVklhMeta || {},
    component: () => import("/webs/pages/user-center.vue").then(m => m.default || m)
  },
  {
    name: "voucher-auto-get",
    path: "/voucher/auto-get",
    component: () => import("/webs/pages/voucher/auto-get.vue").then(m => m.default || m)
  },
  {
    name: "voucher",
    path: "/voucher",
    meta: indexMSGDZy0G83Meta || {},
    component: () => import("/webs/pages/voucher/index.vue").then(m => m.default || m)
  },
  {
    name: "wish-list",
    path: "/wish-list",
    meta: wish_45listnGfF3fHIKmMeta || {},
    component: () => import("/webs/pages/wish-list.vue").then(m => m.default || m)
  }
]